import { render, staticRenderFns } from "./FieldWrapper.vue?vue&type=template&id=bdebf006&"
import script from "./FieldWrapper.vue?vue&type=script&lang=js&"
export * from "./FieldWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FieldWrapper.vue?vue&type=style&index=0&id=bdebf006&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBanner,QField});
